import React, { ReactElement } from 'react';

import styles from './GenderOptionBox.module.css';

import { IGenderOptionBoxProps } from './types';

function GenderOptionBox(props: IGenderOptionBoxProps): ReactElement {
    return <div className={styles.optionWrapper}>{props.children}</div>;
}

export default GenderOptionBox;
